export default __webpack_public_path__ + "static/media/pritifaith.5eb53dc8.jpg";